export default __webpack_public_path__ + "static/media/under-maintenance-dark.52a79bff.svg";